/**
 * Debouncing converts a function to a rate-limited equivalent. The last call will always be invoked.
 * @param f The function you want to rate limit
 * @param delayMs The minimum delay in ms.
 * @returns A new rate-limited function
 */
export default function debounce<F extends (...args: any[]) => any>(
  f: F,
  delayMs: number,
): (...args: Parameters<F>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  return function (...args: Parameters<F>): void {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      f(...args);
    }, delayMs);
  };
}
